var path = '/var/www/mmscny-cms/src/app/components/dashboard/dashboard.html';
var html = "<app-header></app-header> <div> <breadcrumb is-sidebar-open=$ctrl.isSidebarOpen> </breadcrumb> <sidebar list=$ctrl.list is-sidebar-open=$ctrl.isSidebarOpen> </sidebar> <div ui-view class=\"col-md-9 col-lg-9 rightpanel\" ng-class=\"{'side-open-rightpanel': $ctrl.isSidebarOpen}\"></div> </div> <app-footer></app-footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.html
// module id = 765
// module chunks = 0